/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_Reset_ZoomInputs */

const en_image_inspector_reset_zoom = /** @type {(inputs: Image_Inspector_Reset_ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset zoom`)
};

const ar_image_inspector_reset_zoom = /** @type {(inputs: Image_Inspector_Reset_ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إعادة ضبط التكبير`)
};

const bn_image_inspector_reset_zoom = /** @type {(inputs: Image_Inspector_Reset_ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`জুম রিসেট করুন`)
};

const de_image_inspector_reset_zoom = /** @type {(inputs: Image_Inspector_Reset_ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom zurücksetzen`)
};

const es_image_inspector_reset_zoom = /** @type {(inputs: Image_Inspector_Reset_ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restablecer zoom`)
};

const fr_image_inspector_reset_zoom = /** @type {(inputs: Image_Inspector_Reset_ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réinitialiser le zoom`)
};

const pt_image_inspector_reset_zoom = /** @type {(inputs: Image_Inspector_Reset_ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redefinir zoom`)
};

const zh_image_inspector_reset_zoom = /** @type {(inputs: Image_Inspector_Reset_ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重置缩放`)
};

const tr_image_inspector_reset_zoom = /** @type {(inputs: Image_Inspector_Reset_ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yakınlaştırmayı sıfırla`)
};

const ru_image_inspector_reset_zoom = /** @type {(inputs: Image_Inspector_Reset_ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сбросить масштаб`)
};

const pl_image_inspector_reset_zoom = /** @type {(inputs: Image_Inspector_Reset_ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resetuj powiększenie`)
};

/**
* | output |
* | --- |
* | "Reset zoom" |
*
* @param {Image_Inspector_Reset_ZoomInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_reset_zoom = /** @type {((inputs?: Image_Inspector_Reset_ZoomInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_Reset_ZoomInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_reset_zoom(inputs)
	if (locale === "bn") return bn_image_inspector_reset_zoom(inputs)
	if (locale === "de") return de_image_inspector_reset_zoom(inputs)
	if (locale === "es") return es_image_inspector_reset_zoom(inputs)
	if (locale === "fr") return fr_image_inspector_reset_zoom(inputs)
	if (locale === "pt") return pt_image_inspector_reset_zoom(inputs)
	if (locale === "zh") return zh_image_inspector_reset_zoom(inputs)
	if (locale === "tr") return tr_image_inspector_reset_zoom(inputs)
	if (locale === "ru") return ru_image_inspector_reset_zoom(inputs)
	if (locale === "pl") return pl_image_inspector_reset_zoom(inputs)
	return en_image_inspector_reset_zoom(inputs)
});